import { ColumnsType } from 'antd/lib/table';
import dayjs from 'dayjs';
import { Fixed2 } from '../../../../common/utils/common.utils';
import { IVendorPurchaseReportList } from '../types/VendorPurchaseTypes';
import { Typography } from 'antd';

export const VendorPurchaseReportUtils = (): ColumnsType<IVendorPurchaseReportList> => {
  return [
    {
      title: 'SL.',
      dataIndex: 'key',
      key: 'key',
      render: (_, data, index) => <>{1 + index}</>,
    },
    {
      title: 'Date',
      key: 'sales_date',
      render: (_, record) => {
        return `${dayjs(record.sales_date).format('DD MMM YYYY')}`;
      },
    },
    {
      title: 'Invoice No',
      key: 'invoice_no',
      dataIndex: 'invoice_no',

      // render: (_, data) => {
      //   const { vpay_vendor_id, vouchar_no } = data;

      //   return (
      //     <>
      //       <Link to={`../vendors/payment/${vpay_vendor_id}`}>
      //         {vouchar_no}
      //       </Link>
      //     </>
      //   );
      // },
    },

    {
      title: 'Vendor Name',
      key: 'vendor_name',
      dataIndex: 'vendor_name',
    },
    {
      title: 'Total Amount',
      key: 'cost_price',
      dataIndex: 'cost_price',
      align: 'right',
      render: (cost_price) => {
        return <> {Number(Fixed2(cost_price))} </>;
      },
    },
    {
      title: 'Total Payment',
      key: 'payment_amount',
      dataIndex: 'payment_amount',
      align: 'right',
      render: (payment_amount) => {
        return <> {Number(Fixed2(payment_amount))} </>;
      },
    },
    {
      title: 'Total Due',
      key: 'due_amount',
      dataIndex: 'due_amount',
      align: 'right',
      render: (due_amount) => {
        return (
          <Typography.Text style={{ color: Number(due_amount) > 0 ? 'red' : 'green' }}>
            {Number(Fixed2(due_amount))}
          </Typography.Text>
        );
      },
    },
  ];
};
